import Typography from "typography";
import kirkhamTheme from "typography-theme-kirkham";

const typography = new Typography(kirkhamTheme);

export default typography;


// WEBPACK FOOTER //
// ./src/utils/typography.js